import * as React from "react";
import { Badge } from "components/bootstrap";
import StringUtils from "util/StringUtils";
import { formatReadableNumber } from "util/NumberFormatting";
const CounterBadge = ({ count, singular, plural }) => /* @__PURE__ */ React.createElement(Badge, { bsStyle: "default", title: `${count} ${StringUtils.pluralize(count, singular, plural)}` }, formatReadableNumber(count));
export default CounterBadge;
